export const _en = {
    keepOnTrainingProductId: {
        label: "Product referee"
    },
    keepOnTrainingProductModuleId: {
        label: "Product module referee"
    },
    role: {
        label: "Role"
    },
    downtime: {
        label: "Product module referee"
    },
    gapAfter: {
        label: "Immobilization Start after (min)"
    },
    gapBefore: {
        label: "Immobilization Start after (min)"
    },
    resourceId: {
        label: "Set specific resource"
    },
    keepOnTrainingProductModuleTaskId: {
        label: "Keep resource set on"
    },
    skillName: {
        label: "Skill name"
    },
    skillLevel: {
        label: "Skill level"
    },
    isMandatory: {
        label: "Mandatory"
    }
};

export const _fr = {
    keepOnTrainingProductId: {
        label: "Référente stage"
    },
    keepOnTrainingProductModuleId: {
        label: "Référente journée"
    },
    role: {
        label: "Rôle"
    },
    downtime: {
        label: "Durée d’immobilisation"
    },
    gapAfter: {
        label: "A la fin de la séance, immobiliser (encore)"
    },
    gapBefore: {
        label: "Au début de la séance, immobiliser après"
    },
    resourceId: {
        label: "Affecter la ressource nommée"
    },
    keepOnTrainingProductModuleTaskId: {
        label: "Même ressource que celle spécifiée sur l'activité"
    },
    skillName: {
        label: "Nom de la compétence"
    },
    skillLevel: {
        label: "Niveau de la compétence"
    },
    isMandatory: {
        label: "Obligatoire"
    }
};